$ = jQuery;

function languageSwitcher() {
  $(window).on('load', function() {
    if ($('.block-dropdown-languagelanguage-interface')) {
      $('.block-dropdown-language .dropbutton-wrapper').mouseover(function() {
        $(this).addClass('open');
      })
    }
  })
}
